import React, { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { AddCalendarOutline } from '../../../assets/icon/icon';
import { SDatePicker, StyledAddDateButton } from './CalendarDatePicker.styles';

type CalendarDatePickerProps = {
  value?: string;
  buttonLabel?: string;
  placeholder?: string;
  onDateChange?: (date: string | null) => void;
  format?: string;
  disabled?: boolean;
};

const CalendarDatePicker = ({
  value,
  buttonLabel = 'Add',
  placeholder = 'Add Date',
  onDateChange,
  format = 'YYYY-MM-DD',
  disabled = false,
}: CalendarDatePickerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(
    value ? dayjs(value) : null,
  );

  useEffect(() => {
    setSelectedDate(value ? dayjs(value) : null);
  }, [value]);

  const handleDateSelect = (date: Dayjs | null) => {
    // Immediately update the selected date and close the picker
    setSelectedDate(date);
    setIsOpen(false);

    if (onDateChange) {
      onDateChange(date ? date.format(format) : null);
    }
  };

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
  };

  const handleAddClick = () => {
    if (disabled) return;
    setIsOpen(true);
  };

  // If no value, show clickable "Add" text
  if (!value && !isOpen && !selectedDate) {
    return (
      <StyledAddDateButton
        variant="ghost"
        icon={<AddCalendarOutline size={18} />}
        onClick={handleAddClick}
        data-cy="add-date-btn"
        style={{
          color: '#808080',
          cursor: disabled ? 'not-allowed' : '',
        }}
      >
        {buttonLabel}
      </StyledAddDateButton>
    );
  }

  return (
    <SDatePicker
      value={selectedDate}
      onChange={handleDateSelect}
      placeholder={placeholder}
      format="MMM DD, YYYY"
      allowClear={false}
      showToday={false}
      showTime={false}
      open={isOpen}
      onOpenChange={handleOpenChange}
      disabled={disabled}
      suffixIcon={null}
      inputReadOnly
    />
  );
};

export default CalendarDatePicker;
